var map = {
	"./Config.png": 1144,
	"./Exit.png": 9833,
	"./Favoritos.png": 3704,
	"./Fechar.png": 4311,
	"./Logo.png": 6148,
	"./Perfil.png": 3740,
	"./Recentes.png": 2857,
	"./a.png": 5215,
	"./acerte_a_silaba.png": 6931,
	"./addImage.png": 5859,
	"./attention.png": 9848,
	"./background-logo-admin.png": 9645,
	"./banners/Cosmos.png": 1288,
	"./banners/Firewoman.png": 8070,
	"./banners/Homem-Aranha.png": 9090,
	"./banners/Homem-de-Ferro.png": 9496,
	"./banners/Kaya.png": 5713,
	"./banners/Midas.png": 9616,
	"./banners/Mulher-Maravilha.png": 5324,
	"./banners/Nino.png": 1797,
	"./banners/Sony.png": 5656,
	"./banners/Super-Homem.png": 1042,
	"./banners/Trisoma.png": 9325,
	"./banners/Velocitor.png": 6730,
	"./clique_para_colorir.png": 6274,
	"./encontre_a_silaba.png": 3667,
	"./icons/Cosmos.png": 9194,
	"./icons/FireWoman.png": 3598,
	"./icons/Homem-Aranha.png": 2671,
	"./icons/Homem-de-Ferro.png": 745,
	"./icons/Kaya.png": 3116,
	"./icons/Midas.png": 4639,
	"./icons/Mulher-Maravilha.png": 9226,
	"./icons/Nino.png": 7430,
	"./icons/Sony.png": 6033,
	"./icons/Super-Homem.png": 4409,
	"./icons/Trisoma.png": 5374,
	"./icons/Velocitor.png": 6315,
	"./icons/jogo1.png": 5805,
	"./icons/new-player.png": 9843,
	"./img-professores.png": 3739,
	"./jogo1.png": 6908,
	"./jogo2.png": 7033,
	"./jogo3.png": 6968,
	"./jogo4.png": 6142,
	"./jogo5.png": 7320,
	"./jogo_da_memoria.png": 9977,
	"./jogo_de_arrastar.png": 5630,
	"./jogo_de_colorir.png": 3719,
	"./jogo_dos_balaoes.png": 13,
	"./login/img1.png": 7618,
	"./login/img2.png": 9085,
	"./login/img3.png": 3358,
	"./login/institution-logo.png": 5829,
	"./logo-azul.png": 9993,
	"./teachers/user-selected.png": 1141,
	"./teachers/user.png": 1710,
	"./teachers/user1.png": 3995,
	"./teachers/user2.png": 8168,
	"./teachers/user3.png": 2360,
	"./teachers/user4.png": 4273,
	"./teachers/user5.png": 2505,
	"./teachers/user6.png": 6582,
	"./teachers/user7.png": 4598,
	"./teachers/user8.png": 7386,
	"./teachers/user9.png": 5327,
	"./user1-selected.png": 1556,
	"./user2.png": 8458,
	"./user3.png": 2701,
	"./user4.png": 8630,
	"./user5.png": 8890,
	"./user6.png": 3364,
	"./user7.png": 6800,
	"./user8.png": 2017,
	"./user9.png": 9666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;